import { lazy, useMemo } from 'react';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';

// hooks
import useMainRoute from './MainRoutes';

// components
import ComponentsRoutes from './ComponentsRoutes';
import LoginRoutes from './LoginRoutes';
import IndexRedirect from './IndexRedirect';
import Loadable from 'components/Loadable';
import Loader from 'components/Loader';

// utils
import { NavigationListener } from './NavigationListener';
import { restoreQueryLoader, restoreQueryShouldRevalidate } from 'utils/restoreQueryLoader';

const MaintenanceError404 = Loadable(lazy(() => import('pages/maintenance/404')));

// ==============================|| ROUTING RENDER ||============================== //

export default function Router() {
  const { mainRoutes, loading } = useMainRoute();

  const router = useMemo(
    () =>
      createBrowserRouter([
        {
          path: '/',
          loader: restoreQueryLoader,
          shouldRevalidate: restoreQueryShouldRevalidate,
          element: (
            <>
              <NavigationListener />
              <Outlet />
            </>
          ),
          children: [
            {
              path: '/',
              element: <IndexRedirect />
            },
            LoginRoutes,
            ComponentsRoutes,
            mainRoutes,
            {
              path: '*',
              element: <MaintenanceError404 />
            }
          ]
        }
      ]),
    [mainRoutes]
  );

  if (loading) return <Loader />;

  return <RouterProvider router={router} />;
}
